/**
 * The project kickoff with Felix (founder 6495841758, Ross's "how does somebody kick this off").
 *
 * One wording for every way in: the empty project's "Start with Felix" button and the chip
 * offered after Felix creates a project. Both are a person's click, so the prompt is theirs
 * (the auto-send that FB-0005 removed was a message nobody chose). The backend loads its
 * elicitation guidance on "kick off" (persona._select_prompt_sections).
 */
export const KICKOFF_CHIP = "Start the kickoff";

export const KICKOFF_PROMPT = "Let's kick off this project.";

/** Where a newly created project opens: its overview, where the kickoff runs. */
export function projectHomePath(projectId: string): string {
  return `/projects/${projectId}`;
}
